import {
	Harpic,
	checkDocument,
	cleanLSSimilarKey,
	getLSSimilarKey,
	// kukeej,
} from '../../customLib';

import { initAppParams } from '../../params';

const defaultFavs = [
	'btc',
	'btc-usdt',
	'bns-usdt',
	'eth-usdt',
	'usdt',
	'bns',
	'bnsd',
	'bnsg',
	'eth',
	'xrp',
	'xrp-usdt',
	'trx-usdt',
];

// export const oldFavCoinKey = 'favCoins~09-09-18';
export const newFavCoinKey = 'favCoins~02-01-19';
// MM-DD-YY
// export const oldTradesKey = 'startedTrade~09-02-18';
export const newTradesKey = 'startedTrade~06-01-19';

export const initNewTrades = [];

const setNewCoins = oldFavCoins => {
	const favCoins = [];
	const prevFavCoins =
		oldFavCoins; /* .filter(coin => !coin.match(/^(btt)$/)); */

	Array.prototype.push.apply(favCoins, prevFavCoins);
	return favCoins;
};

const setFavs = favCoins => {
	if (checkDocument()) {
		window.localStorage.setItem(
			newFavCoinKey,
			encodeURIComponent(JSON.stringify(favCoins))
		);
	}
	return {
		favCoins,
	};
};

const getFavs = () => {
	let favCoins = defaultFavs.slice(0);
	const oldKey = getLSSimilarKey('favCoins', newFavCoinKey);

	if (checkDocument()) {
		if (!!window.localStorage.getItem(newFavCoinKey)) {
			try {
				favCoins = JSON.parse(
					Harpic(
						decodeURIComponent(
							window.localStorage.getItem(newFavCoinKey)
						)
					)
				);
			} catch (err) {
				console.log(err);
			}
		} else if (!!oldKey) {
			try {
				const oldFavCoins = JSON.parse(
					Harpic(
						decodeURIComponent(
							window.localStorage.getItem(`favCoins~${oldKey}`)
						)
					)
				);

				favCoins = setNewCoins(oldFavCoins);
				setFavs(favCoins);
			} catch (err) {
				console.log(err);
			}
		} /* else if (kukeej.check('favCoins6a')) {
			try {
				const oldFavCoins = JSON.parse(
					Harpic(decodeURIComponent(kukeej.check('favCoins6a')))
				);

				favCoins = setNewCoins(oldFavCoins);

				setFavs(favCoins);

				kukeej.remove('favCoins6a');
				// console.log('remember to remove the old cookie');
			} catch (err) {
				console.log(err);
			}
		} */
		cleanLSSimilarKey('favCoins', newFavCoinKey);
	}
	return favCoins;
};

const addToFavs = ({ favCoins }, coin) => {
	const newFavCoins = favCoins.slice(0);

	if (favCoins.indexOf(coin) === -1) {
		newFavCoins.push(coin);
		return setFavs(newFavCoins);
	}
	return {};
};

const removeFromFavs = ({ favCoins }, coin) => {
	if (favCoins.indexOf(coin) > -1 && favCoins.length > 1) {
		const newFavCoins = favCoins.filter(fav => fav !== coin);
		return setFavs(newFavCoins);
	}
	return {};
};

const checkNewTrade = () => {
	let coins = initNewTrades.slice(0);

	if (checkDocument()) {
		if (!!window.localStorage.getItem(newTradesKey)) {
			try {
				const localcoins = JSON.parse(
					Harpic(
						decodeURIComponent(
							window.localStorage.getItem(newTradesKey)
						)
					)
				);
				coins = initNewTrades.filter(
					coin => localcoins.indexOf(coin) === -1
				);
			} catch (err) {
				console.log(err);
			}
		}
		cleanLSSimilarKey('startedTrade', newTradesKey);
	}
	return coins;
};

const startedNewTrade = ({ newTrades }, newcoin) => {
	if (newTrades.indexOf(newcoin) === -1) {
		return {
			newTrades,
		};
	}

	const updatedTrade = newTrades.slice(0);
	updatedTrade.splice(newTrades.indexOf(newcoin), 1);

	const localTrade = initNewTrades.filter(
		coin => updatedTrade.indexOf(coin) === -1
	);

	if (checkDocument()) {
		window.localStorage.setItem(
			newTradesKey,
			encodeURIComponent(JSON.stringify(localTrade))
		);
	}
	// console.log({ newTrades: updatedTrade });
	return {
		newTrades: updatedTrade,
	};
};

const getAllCoins = (_, res) => res;

export const initCoins = {
	favCoins: getFavs(),
	newTrades: checkNewTrade(),
	marginCoins: [],
	balanceCoins: [],
	depositCoins: [],
	withdrawCoins: [],
	inrCoins: [],
	usdtCoins: [],
	tradeCoins: [],
	swapCoins: [],
	listedCoins: [],
};

// ------------------------------------------------------------

export const coinsActions = {
	/**
	 * Favourites:
	 */
	__setFavs: (state, favs) => setFavs(favs),
	__addToFavs: addToFavs,
	__removeFromFavs: removeFromFavs,
	__getAllCoins: getAllCoins,
	/**
	 * Check for New Trades:
	 */

	__setNewTrade: startedNewTrade,
};
